import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "76.1",
  height: "87.8",
  viewBox: "0 0 76.1 87.8"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M54.9 41.8v-.2c9.4-3.3 14.8-9.9 14.8-17C69.7 4.3 42.7 3 29.9 3H2.1l-.5 2.4 1.6 1.5.6 1.3-.4 1.7.3 2.7 1.4 2-1.6 2.1L0 18.8l1.5 1.8L4 22.8l-.5 1.5 3 3.2v2.7l-1 1.6v1.9l3 3.2.9 3.2-1 2.4v2.2l-1 1.4.9 2.4 1.9 2.1-1 3 1.9 2.4-1 2.2.9 2.7-1 2.7 1.7 2-.5 2.9 2.5 2 3.9.3.3 1.5 1.2.7-.7 2.3 1.5.5.5.7-.5 1.7.8.6-.6 2.2.8.6.5 1.4-1.2 1.6.9 1.4-.1 1.3.1.5h10.5c16.6 0 40.5-3.5 40.5-26-.1-7.4-4.9-15.4-17.2-20",
      "data-logo-small": "back"
    }, null, -1),
    _createElementVNode("path", { d: "M58.9 38.8v-.2c9.4-3.3 14.8-9.9 14.8-17C73.7 1.3 46.7 0 33.9 0H6.1l-.5 2.4 1.6 1.5.6 1.3-.4 1.7.3 2.7 1.4 2-1.6 2.1L4 15.8l1.5 1.8L8 19.8l-.5 1.5 3 3.2v2.7l-1 1.6v1.9l3 3.2.9 3.2-1 2.4v2.2l-1 1.4.9 2.4 1.9 2.1-1 3 1.9 2.4-1 2.2.9 2.7-1 2.7 1.7 2-.5 2.9 2.5 2 3.9.3.3 1.5 1.2.7-.7 2.3 1.5.5.5.7-.5 1.7.8.6-.6 2.2.8.6.5 1.4-1.2 1.6.9 1.4-.1 1.3.1.5h10.5c16.6 0 40.5-3.5 40.5-26-.1-7.4-4.9-15.4-17.2-20" }, null, -1)
  ]))]))
}
export default { render: render }